import Resource from './Resource'

const apiURL = `https://${process.env.VUE_APP_API_URL}`
let repositories = {}

export default {
  init: JWT => {
    repositories = {
      AdjustInventories: new Resource(JWT, { apiURL, resource: 'adjust_inventories' }),
      AdjustOrdering: new Resource(JWT, { apiURL, resource: 'adjust_ordering' }),
      Articles: new Resource(JWT, { apiURL, resource: 'articles' }),
      Banners: new Resource(JWT, { apiURL, resource: 'banners' }),
      Cars: new Resource(JWT, { apiURL, resource: 'cars' }),
      CashRegistries: new Resource(JWT, { apiURL, resource: 'cash_registries' }),
      Categories: new Resource(JWT, { apiURL, resource: 'categories' }),
      Enums: new Resource(JWT, { apiURL, resource: 'enums' }),
      Files: new Resource(JWT, { apiURL, resource: 'files' }),
      Inventories: new Resource(JWT, { apiURL, resource: 'inventories' }),
      Warehouses: new Resource(JWT, { apiURL, resource: 'warehouses' }),
      Mercure: new Resource(JWT, { apiURL, resource: 'mercure' }),
      Navigations: new Resource(JWT, { apiURL, resource: 'navigations' }),
      OptimalCarInventories: new Resource(JWT, { apiURL, resource: 'optimal_car_inventories' }),
      Orders: new Resource(JWT, { apiURL, resource: 'orders' }),
      Products: new Resource(JWT, { apiURL, resource: 'products' }),
      ProductVariants: new Resource(JWT, { apiURL, resource: 'product_variants' }),
      Settings: new Resource(JWT, { apiURL, resource: 'settings' }),
      Streets: new Resource(JWT, { apiURL, resource: 'streets' }),
      Users: new Resource(JWT, { apiURL, resource: 'users' }),
      WebPages: new Resource(JWT, { apiURL, resource: 'web_pages' }),
      FirebaseMessage: new Resource(JWT, { apiURL, resource: 'firebase/message/send' }),
    }
  },
  get: name => repositories[name],
}
